import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { BidStatus } from "../../autogen/bff-api";
import { BidStatusTag } from "./BidStatusTag";

interface Props {
  bidStatus?: BidStatus;
  // Forwarded to BidStatusTag so a still-SUBMITTED bid reads as "not selected" once the
  // event has reached an award decision.
  awarded?: boolean;
  size?: "sm" | "md" | "lg";
}

// Shows the delivered-bid status when a company has submitted (only revealed after the deadline),
// otherwise the neutral "registered interest" state.
export const SupplierStatusTag = ({ bidStatus, awarded = false, size = "sm" }: Props) => {
  const { t } = useTranslation();
  if (bidStatus) {
    return <BidStatusTag status={bidStatus} awarded={awarded} size={size} />;
  }
  return (
    <Tag colorScheme="blue" size={size} borderRadius="full">
      {t("Registered interest")}
    </Tag>
  );
};
